import PuzzleStart from './screens/PuzzleStart'
import PuzzleGame from './screens/PuzzleGame'
import PuzzleEnd from './screens/PuzzleEnd'
import { usePuzzle } from '../context/PuzzleContext'
import { useDocumentMetadata } from '@hooks/useDocumentMetadata'
import { useNamespaces } from '@hooks/useNamespaces'
import { ROUTE_NAMESPACES } from '@i18n/namespaces'
import ScreenFallback from '@components/layout/ScreenFallback'

/**
 * Orchestrates puzzle flow using PuzzleContext (no URL coupling).
 * SRP: coordinates screens and wiring callbacks; screens remain black boxes.
 */
export default function PuzzleScreen () {
  useDocumentMetadata()

  const {
    stage, // 'start' | 'game' | 'end'
    difficulty, // 'easy' | 'medium' | 'hard'
    startGame, // (d) => void
    exitToStart, // () => void
    finishGame // () => void
  } = usePuzzle()

  const { isLoading: namespacesLoading } = useNamespaces(ROUTE_NAMESPACES.puzzle)
  if (namespacesLoading) {
    return <ScreenFallback />
  }

  if (stage === 'game') {
    return (
      <PuzzleGame
        difficulty={difficulty}
        onExit={exitToStart}
        onSolved={finishGame} // PuzzleGame must call this when engine reports solved
      />
    )
  }

  if (stage === 'end') {
    return (
      <PuzzleEnd
        onRestart={exitToStart}
      />
    )
  }

  // Default: start (uses initialDifficulty just for preselection UI)
  return (
    <PuzzleStart
      initialDifficulty={difficulty}
      onGameStart={startGame}
    />
  )
}
